// Module
var code = "<p>Your API-key is required to integrate with our API.</p> <p><strong>Note:</strong> Your API-key carries privileges, please keep it secure and do not share your secret API-key.</p> ";
// Exports
module.exports = code;